function getApiBase() {
  const base = localStorage.baseUrl || localStorage.ip || ''
  return String(base).replace(/\/$/, '') + '/api/app'
}

function emitError(text) {
  if (!text) return
  window.dispatchEvent(new CustomEvent('app-message', { detail: { type: 'error', text } }))
}

function failResult(message, silent) {
  if (!silent) emitError(message)
  return { success: false, message, handled: !silent }
}

async function request(url, options = {}) {
  const { silent = false, ...fetchOptions } = options
  try {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      ...fetchOptions
    })

    let payload
    try {
      payload = await res.json()
    } catch (e) {
      return failResult(res.ok ? '服务器响应异常' : `服务器错误: ${res.status}`, silent)
    }

    if (payload && payload.success === false) {
      return failResult(payload.message || '请求失败', silent)
    }
    if (!res.ok) {
      return failResult((payload && payload.message) || `服务器错误: ${res.status}`, silent)
    }
    return payload
  } catch (e) {
    console.error('API request failed:', e)
    return failResult('网络连接失败，请检查服务器是否启动', silent)
  }
}

export default {
  createRoom(params) {
    return request(`${getApiBase()}/rooms`, {
      method: 'POST',
      body: JSON.stringify(params)
    })
  },

  joinRoom(roomId, params) {
    return request(`${getApiBase()}/rooms/${roomId}/join`, {
      method: 'POST',
      body: JSON.stringify(params)
    })
  },

  leaveRoom(roomId, params, silent = false) {
    return request(`${getApiBase()}/rooms/${roomId}/leave`, {
      method: 'POST',
      body: JSON.stringify(params),
      silent
    })
  },

  getRoom(roomId, playerId) {
    const query = playerId ? `?playerId=${encodeURIComponent(playerId)}` : ''
    return request(`${getApiBase()}/rooms/${roomId}${query}`, { silent: true })
  },

  updateNickname(roomId, params) {
    return request(`${getApiBase()}/rooms/${roomId}/nickname`, {
      method: 'POST',
      body: JSON.stringify(params)
    })
  },

  setReady(roomId, params) {
    return request(`${getApiBase()}/rooms/${roomId}/ready`, {
      method: 'POST',
      body: JSON.stringify(params)
    })
  },

  startGame(roomId, params) {
    return request(`${getApiBase()}/rooms/${roomId}/start`, {
      method: 'POST',
      body: JSON.stringify(params)
    })
  }
}
